import { BetAccountHolder } from '@mobi/api-types'
import { get } from '@core/Services/ApiService'

export const getContactDetails = () => get<BetAccountHolder>({ url: '/api/contactDetails' })
